<template>
	<b-modal 
		id="modal-cloturate"
		centered 
		content-class="shadow" 
		title="Cloture de la réservation"
		:no-close-on-esc="true"
		:no-close-on-backdrop="true"
		:hide-header-close="true"
		@hidden="resetModal"
		@ok="handleOk">
			<p>Voulez-vous cloturer la réservation ?</p>
			<b-form ref="form" validated>
				<b-form-group
					label="Cumul d'activité : (à modifier si besoin)">
					<b-input-group :append="unitTitle">
						<b-form-input v-model="cumulValid" type="number" min="0" step="0.01"/>
					</b-input-group>
				</b-form-group>
			</b-form>
			<b-alert variant="danger" :show="isServerError">Une erreur inattendue est survenue. Si elle persiste, veuillez contacter Kemtag.</b-alert>
			<template v-slot:modal-footer="{ ok, cancel}">
				<div v-if="!isBusy">
					<b-button size="sm" variant="danger" @click="cancel()">
						Annuler
					</b-button>
					<b-button size="sm" variant="primary" @click="ok()">
						Cloturer
					</b-button>
				</div>
				<b-button  size="sm" variant="primary" disabled v-if="isBusy">
			    	<b-spinner small></b-spinner>
			    	Validation...
			  	</b-button>
			</template>
		</b-modal>

</template>

<script>

	export default {
		name: "CalendarCloturate",
		data: ()  => ({
			isBusy: false,
			isServerError: false,
			cumulValid : 0,
			id: null,
			unitTitle: null
		}),
		methods : {
			show(id, cumul, unit_title) {
				this.isBusy = false;
				this.isServerError = false;
				this.cumulValid = cumul;
				this.id = id;
				this.unitTitle = unit_title;

				this.$bvModal.show("modal-cloturate");
			},
			resetModal(e) {

				// Gérer l'annulation du popup ici
				

			}, 
			handleOk(e) {


				// Prevent modal from closing
				e.preventDefault()
				// Trigger submit handler
				this.handleSubmit()
			},
			handleSubmit() {

				if (!this.checkFormValidity()) {
					return
				}

				this.isBusy = true;
				this.$store.dispatch('rentals/confirm', {
					id: this.id,
					cumul_valid: this.cumulValid
				}).then(() => {
					this.isBusy = false;
					this.$bvModal.hide('modal-cloturate')
					this.$emit('onCloturateSuccess')
					this.isServerError = false;
				}).catch((error) => {
		        	this.isServerError = true
		        	this.isBusy = false
		        })

				
			},
			checkFormValidity() {
				const valid = this.$refs.form.checkValidity()
				//this.nameState = valid
				return valid
			},
		}
	}
</script>